import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@devinforius/super-compos-17';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ApiService } from 'src/app/core/services/api.service';
import { Meeting } from 'src/app/shared/models/meeting';
import * as async from 'async';
import * as moment from 'moment';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-infos-meeting-edit',
  templateUrl: './infos-meeting-edit.component.html',
  styleUrls: ['./infos-meeting-edit.component.scss'],
})
export class InfosMeetingEditComponent implements OnInit {
  public header = '';
  public meeting: Meeting = null;
  public adressList = [];

  public form: UntypedFormGroup = new UntypedFormGroup({
    description: new UntypedFormControl(),
    date: new UntypedFormControl(),
    heureDebut: new UntypedFormControl(),
    heureFin: new UntypedFormControl(),
    reunionFixeeLe: new UntypedFormControl(),
    reunionFixeePar: new UntypedFormControl(),
    lieuxId: new UntypedFormControl(),
    urlStreaming: new UntypedFormControl(),
  });

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public translate: TranslateService,
    public api: ApiService,
    public IDelibeGlobalService: IDelibeGlobalService,
    public apiAdmin: iAdminService,
    public toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    async.waterfall([
      (callback) => {
        this.header = this.config.data.header;
        this.meeting = this.config.data.meeting;
        callback();
      },
      (callback) => {
        this.IDelibeGlobalService.getGlobalLieux().subscribe((res: any) => {
          this.adressList = res;
          callback();
        });
      },
      (callback) => {
        this.form.patchValue({
          description: this.meeting.description,
          date: this.meeting.date ? moment(this.meeting.date).toDate() : null,
          heureDebut: {
            hour: this.meeting.heureDebut ? new Date(this.meeting.heureDebut).getHours() : null,
            minute: this.meeting.heureDebut ? new Date(this.meeting.heureDebut).getMinutes() : null,
          },
          heureFin: {
            hour: this.meeting.heureFin ? new Date(this.meeting.heureFin).getHours() : null,
            minute: this.meeting.heureFin ? new Date(this.meeting.heureFin).getMinutes() : null,
          },
          reunionFixeeLe: this.meeting.reunionFixeeLe ? moment(this.meeting.reunionFixeeLe).toDate() : null,
          reunionFixeePar: this.meeting.reunionFixeePar,
          lieuxId: this.meeting.lieuxId,
          urlStreaming: this.meeting.urlStreaming,
        });
        callback();
      },
    ]);
  }

  submitModificationMeeting() {
    const data = {
      heureDebut: null,
      heureFin: null,
      description: this.form.value.description,
      date: this.form.value.date,
      reunionFixeeLe: this.form.value.reunionFixeeLe,
      reunionFixeePar: this.form.value.reunionFixeePar,
      lieuxId: this.form.value.lieuxId,
      urlStreaming: this.form.value.urlStreaming,
    };
    const dataTarget1 = new Date();
    const dataTarget2 = new Date();
    async.waterfall([
      (cb) => {
        console.log('this.form.value.heureDebut ==>', this.form.value);
        if (this.form.value.heureDebut && (this.form.value.heureDebut.hour || this.form.value.heureDebut.minute)) {
          const heureDebut = this.form.value.heureDebut;
          console.log('heureDebut ==>', heureDebut);
          dataTarget1.setHours(heureDebut.hour);
          dataTarget1.setMinutes(heureDebut.minute);
          data.heureDebut = moment(dataTarget1).format('YYYY-MM-DDTHH:mm:ss');
        } else {
          console.log('this.form.value.heureDebut ==>', this.form.value.heureDebut);
          if (
            this.form.value.heureDebut === null ||
            (
              typeof this.form.value.heureDebut === 'object' &&
              !('hour' in this.form.value.heureDebut) &&
              !('minute' in this.form.value.heureDebut)
            )
          ) {
            this.toastr.error('La date de début n\'a pas été remplie complètement, elle ne sera pas prise en compte');
          }
          data.heureDebut = null;
        }
        cb(null);
      },
      (cb) => {
        console.log('this.form.value.heureFin ==>', this.form.value);
        if (this.form.value.heureFin && (this.form.value.heureFin.hour || this.form.value.heureFin.minute)) {
          const heureFin = this.form.value.heureFin;
          console.log('heureFin ==>', heureFin);
          dataTarget2.setHours(heureFin.hour);
          dataTarget2.setMinutes(heureFin.minute);
          data.heureFin = moment(dataTarget2).format('YYYY-MM-DDTHH:mm:ss');
        } else {
          if (
            this.form.value.heureFin === null ||
            (
              typeof this.form.value.heureFin === 'object' &&
              !('hour' in this.form.value.heureFin) &&
              !('minute' in this.form.value.heureFin)
            )
          ) {
            this.toastr.error('La date de fin n\'a pas été remplie complètement, elle ne sera pas prise en compte');
          }
          data.heureFin = null;
        }
        cb(null);
      },
      (cb) => {
        this.ref.close(data);
      },
    ]);
  }
}
